export enum EnumRegime {
    SIMPLES_NACIONAL = 1,
    SIMPLEX_NACIONAL_EX_SUBLIMITE_RECEITA_BRUTA = 2,
    LUCRO_REAL = 3,
    LUCRO_PRESUMIDO = 4,
    MEI = 5,
    NAOSEAPLICA = 9
}